import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCT_IMAGES } from '../data/mock';
import { useProducts } from '../hooks/useProducts';

const stories = [
  { eyebrow: 'Chapter One', title: 'Mornings, slowed.', body: 'A quiet start to the day — cleanse, serum, SPF. Not a ritual to perform, but one to live inside.', link: '/shop?category=skincare', linkLabel: 'The skincare edit' },
  { eyebrow: 'Chapter Two', title: 'Everyday metal.', body: 'A chain you forget you’re wearing until someone asks. 316L steel, gold-plated, waterproof — made for your life.', link: '/shop?category=jewelry', linkLabel: 'Jewelry we love' },
  { eyebrow: 'Chapter Three', title: 'Softness as a stance.', body: 'Scalp care, facial tools, slow evenings. Permission to care for yourself out loud.', link: '/shop?category=selfcare', linkLabel: 'Rituals for the week' },
];

export default function LookbookPage() {
  const { products } = useProducts();
  const picks = products.slice(0, 6);
  const imgs = [PRODUCT_IMAGES.heroWomen, PRODUCT_IMAGES.heroMen, PRODUCT_IMAGES.lookbookA, PRODUCT_IMAGES.lookbookB, PRODUCT_IMAGES.catSkincare, PRODUCT_IMAGES.catJewelry];
  return (
    <div className="fade-in">
      <section className="relative overflow-hidden">
        <div className="aspect-[16/9] max-h-[85vh] w-full overflow-hidden md:aspect-[21/9]">
          <img src={PRODUCT_IMAGES.lookbookB} alt="Lookbook" className="h-full w-full object-cover object-[center_25%]" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-espresso/70 via-espresso/10 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full p-8 text-ivory md:p-16">
          <p className="eyebrow text-gold">The Lookbook · Vol. 01</p>
          <h1 className="mt-3 font-display text-5xl leading-[1.05] md:text-7xl">Quiet. Confident.<br/><em className="text-gold not-italic">Yours.</em></h1>
          <p className="mt-5 max-w-xl text-ivory/90">A scrollable portrait of our Autumn drop — skincare, jewelry and softly chosen rituals, photographed in natural light.</p>
        </div>
      </section>

      {stories.map((s, i) => (
        <section key={i} className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
          <div className={`grid gap-10 md:grid-cols-2 md:items-center ${i % 2 ? 'md:[&>*:first-child]:order-2' : ''}`}>
            <div className="overflow-hidden bg-champagne">
              <img src={imgs[(i * 2) % imgs.length]} alt={s.title} className="aspect-[4/5] w-full object-cover" />
            </div>
            <div>
              <p className="eyebrow text-espresso/60">{s.eyebrow}</p>
              <h2 className="mt-3 font-display text-5xl leading-[1.05] md:text-6xl">{s.title}</h2>
              <p className="mt-6 max-w-prose text-espresso/80">{s.body}</p>
              <Link to={s.link} className="mt-8 inline-block border-b border-espresso pb-1 text-[11px] tracking-[0.18em] text-espresso">{s.linkLabel.toUpperCase()}</Link>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4">
            {imgs.slice(0, 4).map((u, j) => (
              <div key={j} className="aspect-[3/4] overflow-hidden bg-champagne"><img src={u} alt="" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" /></div>
            ))}
          </div>
        </section>
      ))}

      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
        <p className="eyebrow text-espresso/60">Shop the lookbook</p>
        <h2 className="mt-3 font-display text-5xl">Pieces from the shoot.</h2>
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {picks.map((p) => (
            <Link key={p.id} to={`/product/${p.id}`} className="group block">
              <div className="aspect-[4/5] overflow-hidden bg-champagne">
                <img src={p.image} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="mt-4 flex items-start justify-between">
                <h3 className="font-display text-xl">{p.title}</h3>
                <span className="text-sm">R {Number(p.price).toFixed(0)}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
